import { useContext } from 'react';

import { useInView } from 'react-intersection-observer';

import { ImpressionsBatcherContext } from './ImpressionsBatcherProvider';
import { type ImpressionsBatcherHookArgs, TileType } from './types';

export function useImpressionsBatcher({
  productId,
  shouldCollectImpression = true,
  tileType = TileType.Organic,
  moduleName,
  prices,
  position,
  isEnd,
  page,
}: ImpressionsBatcherHookArgs) {
  const { impressions, setImpressions, rootMargin } = useContext(
    ImpressionsBatcherContext
  );

  const isImpressionsBatcherReady = Boolean(rootMargin);

  const { ref } = useInView({
    threshold: 0,
    rootMargin,
    onChange: (inView) => {
      if (
        isImpressionsBatcherReady &&
        shouldCollectImpression &&
        inView &&
        productId
      ) {
        setImpressions((previousImpressions) => [
          ...previousImpressions,
          {
            impressionTime: new Date().toISOString(),
            productId,
            tileType,
            prices,
            position,
            ...(moduleName && { component: moduleName }),
            isEnd,
            ...(page && { page }),
          },
        ]);
      }
    },
  });

  return { impressions, impressionRef: ref };
}
